import React, { useState, useEffect } from 'react'
import { Container, Form, Stack, Button, Navbar } from 'react-bootstrap'
import Vanta from './Vanta'
import { Link } from "react-scroll";
import { useDispatch } from 'react-redux'
import { setLink } from '../action/linkAction'


const LandingPage = () => {
    const dispatch = useDispatch()

    function range(start, end) {
        return Array(end - start + 1).fill().map((_, idx) => start + idx)
    }

    var result = range(2003, 2021);


    const [year, setYear] = useState()
    const prevYear = localStorage.getItem('year')
    const [officialLink, setOfficialLink] = useState("https://web.archive.org/web/" + prevYear + "1230/https://")

    useEffect(() => {
        dispatch(setLink(officialLink))
        localStorage.setItem('link', officialLink)

    }, [dispatch, officialLink])





    return (
        <>
            <Vanta>
                <Navbar>
                    <Container>
                        <Navbar.Brand style={{ color: 'white', userSelect: 'none', fontSize: 'xx-large', fontWeight: '100' }}>AGES AGO</Navbar.Brand>
                    </Container>
                </Navbar>
                <Container style={{ height: '100vh', display: 'flex', alignItems: 'center' }}>

                    <Container style={{ width: 'fit-content', textAlign: 'center' }} >

                        <Stack gap={2} style={{ alignItems: 'center' }}>
                            <span style={{ color: 'white', userSelect: 'none', fontSize: 'xx-large', fontWeight: '300' }}>Checkout how websites where used to be in the past years..</span>

                            <Form.Select value={year} style={{ width: 'fit-content' }} onChange={(e) => { setYear(e.target.value); localStorage.setItem('year', e.target.value); setOfficialLink("https://web.archive.org/web/" + e.target.value + "1230/https://") }}>
                                <option>SELECT YEAR</option>
                                {result.reverse().map((option) => (
                                    <option key={option + 1} value={option}>{option}</option>
                                ))}
                            </Form.Select>
                            {!(localStorage.getItem("year") === null || localStorage.getItem("year") === "SELECT YEAR") && (<Link
                                activeClass="active"
                                to="sites"
                                spy={true}
                                smooth={true}
                                offset={0}
                                duration={500}
                            ><Button style={{ width: 'fit-content' }} variant="outline-light">Lets GO!</Button></Link>)}
                        </Stack>
                    </Container>
                </Container>
            </Vanta>
        </>
    )
}

export default LandingPage
